// FONT-SIZES
const fontSizes = Array.from( { length: 60 }, ( v, k ) => k + 8 )

//BORDERS
const borderSizes = Array.from( { length: 30 }, ( v, k ) => k + 1 )

// CONVERT HEX TO RGBA
const hexToRgba = hex => {
  var result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec( hex )
  return result
    ? {
      r: parseInt( result[1], 16 ),
      g: parseInt( result[2], 16 ),
      b: parseInt( result[3], 16 )
    }
    : null
}

// CONVERT RGBA TO HEX
const rgbToHex = rgb => {
  if ( !rgb ) return
  rgb = rgb.match(
    /^rgba?[\s+]?\([\s+]?(\d+)[\s+]?,[\s+]?(\d+)[\s+]?,[\s+]?(\d+)[\s+]?/i
  )
  return rgb && rgb.length === 4
    ? '#' +
        ( '0' + parseInt( rgb[1], 10 ).toString( 16 ) ).slice( -2 ) +
        ( '0' + parseInt( rgb[2], 10 ).toString( 16 ) ).slice( -2 ) +
        ( '0' + parseInt( rgb[3], 10 ).toString( 16 ) ).slice( -2 )
    : ''
}

// Regex from string
const regexName = string => {
  return string.replace( /[`~!@#$%^&*()_|+\=?;:'",.<>\{\}\[\]\\\/\u0000]/gi, '' )
}


export {
  fontSizes,
  borderSizes,
  hexToRgba,
  rgbToHex,
  regexName,
}



// WEBPACK FOOTER //
// ./src/components/commons/editor/configs/Comoons.js